/**
 * jobPricing — service list, frontend price mirror and the scope maths shared
 * by the Jobs screen and the Edit Job modal. Mirrors backend/pricing.js; the
 * backend recomputes on save, this is only for the live preview.
 */

export const ALL_DEPARTMENTS = ['KIA CARS', 'SUZUKI CARS', 'GWM CARS', 'GAC CARS', 'USED CARS', 'OFFICE', 'SERVICE', 'PRIVATE'];

export const JOB_DESCRIPTIONS = [
  'DELIVERY', 'DEMO', 'FIRST CLEAN', 'MINI DETAIL',
  'SMALL FULL DETAIL', 'MEDIUM FULL DETAIL', 'LARGE FULL DETAIL',
  'EXTRA LARGE FULL DETAIL', 'BUFFING', 'RECLEAN',
  'PAINT PROTECTION', 'SERVICE WASH DAILY', 'STRIP TINT', 'SEAT CLEANING', 'CLAYBLOCK',
  'DAILY OFFICE CLEAN', 'MOP SHOWROOM', 'YARD CLEAN', 'SHOWROOM CARS',
];

export const FRONTEND_PRICING = {
  'FIRST CLEAN':             { full: 75.00,  pay: 50.00  },
  'DELIVERY':                { full: 37.50,  pay: 25.00  },
  'DEMO':                    { full: 35.00,  pay: 23.00  },
  'RECLEAN':                 { full: 6.50,   pay: 5.00   },
  'MINI DETAIL':             { full: 85.00,  pay: 55.00  },
  'SMALL FULL DETAIL':       { full: 150.00, pay: 100.00 },
  'MEDIUM FULL DETAIL':      { full: 175.00, pay: 115.00 },
  'LARGE FULL DETAIL':       { full: 215.00, pay: 140.00 },
  'EXTRA LARGE FULL DETAIL': { full: 260.00, pay: 170.00 },
  'BUFFING':                 { full: 200.00, pay: 140.00 },
  'CLAYBLOCK':               { full: 35.00,  pay: 23.00  },
  'STRIP TINT':              { full: 50.00,  pay: 35.00  },
  'SEAT CLEANING':           { full: 60.00,  pay: 40.00  },
  'SERVICE WASH DAILY':      { full: 300.00, pay: 220.00 },
  'PAINT PROTECTION':        { full: 65.00,  pay: 50.00  },
  'DAILY OFFICE CLEAN':      { full: 174.00, pay: 100.00 },
  'MOP SHOWROOM':            { full: 50.00,  pay: 40.00  },
  'YARD CLEAN':              { full: 6.50,   pay: 5.50   },
  'SHOWROOM CARS':           { full: 6.50,   pay: 5.50   },
  'HOURS':                   { full: 35.00,  pay: 23.00  },
};

// Auto-assign department from the main service.
export const DEPT_AUTO = {
  'FIRST CLEAN': 'SERVICE', 'PAINT PROTECTION': 'SERVICE', 'SERVICE WASH DAILY': 'SERVICE',
  'MINI DETAIL': 'USED CARS', 'SMALL FULL DETAIL': 'USED CARS', 'MEDIUM FULL DETAIL': 'USED CARS',
  'LARGE FULL DETAIL': 'USED CARS', 'EXTRA LARGE FULL DETAIL': 'USED CARS',
  'STRIP TINT': 'USED CARS', 'SEAT CLEANING': 'USED CARS',
  'DAILY OFFICE CLEAN': 'OFFICE', 'MOP SHOWROOM': 'OFFICE',
};

export const SCOPE_OPTS  = [{ v: 0.3, l: '30%' }, { v: 0.5, l: '50%' }, { v: 0.7, l: '70%' }, { v: 1, l: 'Full' }];
export const HOUR_OPTS   = [0.5, 1, 1.5, 2, 3, 4, 5, 6, 7, 8];
export const EDIT_EXTRAS = ['BUFFING', 'HOURS', 'CLAYBLOCK', 'STRIP TINT', 'SEAT CLEANING', 'PAINT PROTECTION'];

export function calcFrontendRevenue(desc, extrasObjs, mainUnits = 1) {
  const main = FRONTEND_PRICING[desc] || { full: 0, pay: 0 };
  const mu   = parseFloat(mainUnits) > 0 ? parseFloat(mainUnits) : 1;
  return extrasObjs.reduce((acc, e) => {
    const svc   = typeof e === 'string' ? e : (e.service || e);
    const units = typeof e === 'string' ? 1 : (parseFloat(e.units) || 1);
    const ep    = FRONTEND_PRICING[svc] || { full: 0, pay: 0 };
    return { full: acc.full + ep.full * units, pay: acc.pay + ep.pay * units };
  }, { full: main.full * mu, pay: main.pay * mu });
}

// Car colours offered in the picker — same list the Submit Job form uses.
export const COLOURS = [
  { name: 'White', sw: '#fff', bd: '1px solid #d1d5db' }, { name: 'Black', sw: '#0a0a0a' },
  { name: 'Silver', sw: '#c0c6cc' }, { name: 'Grey', sw: '#6b7280' },
  { name: 'Blue', sw: '#2563eb' }, { name: 'Red', sw: '#dc2626' },
  { name: 'Green', sw: '#16a34a' }, { name: 'Yellow', sw: '#F5C518' },
  { name: 'Beige', sw: '#d6c6a8' }, { name: 'Other', sw: '#fff', bd: '1.5px dashed #98a2b3' },
];
